<template>
  <a-modal
    title="批量导入学生"
    :width="400"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :footer="null"
  >
    <h3>请先下载Excel模板，按照要求填写信息后，再上传Excel！</h3>
    <p>注意：请不要修改表格的结构和文件类型</p>
    <br>
    <a-row type="flex" justify="center" style="text-align:center;">
      <a-col :span="12">
          <a-button type="default">下载Excel模板</a-button>
      </a-col>
      <a-col :span="12">
          <a-button type="primary">导入Excel文件</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>

  export default {
    name: "ImportStudentModal",
    data () {
      return {
        visible: false,
      }
    },
    created () {
      console.log("created");
    },

    methods: {
      show () {
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleSubmit () {

      },
      handleCancel () {
        this.close()
      },
    
    /* 导入 */
    handleImportExcel(info){
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 201) {
            let { message, result: { msg, fileUrl, fileName } } = info.file.response
            let href = window._CONFIG['domianURL'] + fileUrl
            this.$warning({
              title: message,
              content: (
                <div>
                  <span>{msg}</span><br/>
                  <span>具体详情请 <a href={href} target="_blank" download={fileName}>点击下载</a> </span>
                </div>
              )
            })
          } else {
            this.$message.success(info.file.response.message || `${info.file.name} 文件上传成功`)
          }
          this.loadData()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败: ${info.file.msg} `);
      }
    },
    }
  }
</script>